import { KanbanColumnId, KanbanTaskType, TasksDashboardFilterKey, TasksDashboardView } from "../models";

/**
 * Fixed left-to-right column order. Unassigned is always the leftmost column and Completed the
 * rightmost; neither can be reordered.
 */
export const KANBAN_COLUMN_ORDER: KanbanColumnId[] = [
  "unassigned",
  "not-started",
  "in-progress",
  "in-review",
  "blocked",
  "completed",
];

export const KANBAN_COLUMN_LABELS: Record<KanbanColumnId, string> = {
  unassigned: "Unassigned",
  // Labelled with the statuses the backend actually stores, so a lane reads the same as the task's
  // status everywhere else in the app (REQ-004).
  "not-started": "To do",
  "in-progress": "In progress",
  "in-review": "In review",
  blocked: "Blocked",
  completed: "Complete",
};

export const COMPLETED_COLUMN_ID: KanbanColumnId = "completed";
export const UNASSIGNED_COLUMN_ID: KanbanColumnId = "unassigned";

export const TASKS_DASHBOARD_VIEWS: { view: TasksDashboardView; label: string }[] = [
  { view: "kanban", label: "Kanban" },
  { view: "gantt", label: "Gantt chart" },
  { view: "list", label: "List" },
];

export const TASKS_DASHBOARD_FILTERS: { key: TasksDashboardFilterKey; placeholder: string }[] = [
  { key: "assignee", placeholder: "Assignee" },
  { key: "taskType", placeholder: "Task type" },
  { key: "objectName", placeholder: "Project, deal…" },
  { key: "tag", placeholder: "Tag" },
];

/** Object-type labels, shown alongside the object name in the "Project, deal or landholding" filter.
 *  A landholding is a group of projects: selecting one filters to every task under its projects.
 *  Tasks never link to a landholding directly (only project/deal), so landholding filter options are
 *  host/server-supplied and the landholding→projects match is resolved server-side. */
export const OBJECT_TYPE_LABELS: Record<string, string> = {
  project: "Project",
  deal: "Deal",
  landholding: "Landholding",
};

/** Task-type labels for the "Task type" filter and the "New task" menu. */
export const TASK_TYPE_LABELS: Record<KanbanTaskType, string> = {
  workflow: "Workflow",
  general: "General",
};
